(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-hero-gateway"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rr-hero-story')) {
    customElements.define('rr-hero-story', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-duet') || this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.scenes = [...this.querySelectorAll('[data-scene]')];
        this.chapters = [...this.querySelectorAll('[data-chapter]')];
        this.toggle = this.querySelector('.rr-story__toggle');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.active = 0;
        this.animations = [];
        this.paused = this.motion.matches || this.dataset.autoplay !== 'true' || Boolean(window.Shopify?.designMode);
        this.inView = false;
        this.toggle.hidden = false;
        this.updateToggle();
        this.chapters.forEach((chapter, index) => chapter.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.paused = true;
          this.updateToggle();
          this.stopTimer();
          this.show(index, true);
        }, { signal }));
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updateToggle();
          this.schedule();
        }, { signal });
        this.addEventListener('focusin', event => {
          if (event.target === this.toggle) return;
          this.paused = true;
          this.updateToggle();
          this.stopTimer();
        }, { signal });
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || !event.target.closest('.rr-story__controls')) return;
          event.preventDefault();
          this.paused = true;
          this.updateToggle();
          this.show(1 - this.active, true);
        }, { signal });
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.stopTimer(); } }, { signal });
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
        this.addEventListener('touchstart', event => { this.touch = [event.touches[0].clientX, event.touches[0].clientY]; }, { signal, passive: true });
        this.addEventListener('touchend', event => {
          if (!this.touch) return;
          const dx = event.changedTouches[0].clientX - this.touch[0];
          const dy = event.changedTouches[0].clientY - this.touch[1];
          this.touch = null;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            this.paused = true;
            this.updateToggle();
            this.show(1 - this.active, true);
          }
        }, { signal, passive: true });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) { this.paused = true; this.animations.forEach(animation => animation.finish()); }
          this.updateToggle();
          this.schedule();
        }, { signal });
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: .3 });
        this.observer.observe(this);
      }
      updateToggle() {
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        this.toggle.querySelector('[data-pause-icon]').hidden = this.paused;
        this.toggle.querySelector('[data-play-icon]').hidden = !this.paused;
      }
      stopTimer() {
        clearTimeout(this.timer);
        this.progress?.cancel();
      }
      schedule() {
        this.stopTimer();
        if (this.paused || this.busy || !this.inView || this.hovered || document.hidden || !this.isConnected) return;
        const duration = Number(this.dataset.duration) || 8500;
        if (!this.motion.matches) this.progress = this.chapters[this.active].querySelector('.rr-story__track > span').animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration, fill: 'forwards' });
        this.timer = setTimeout(() => this.show(1 - this.active), duration);
      }
      async show(index, manual = false) {
        if (this.busy || index === this.active) return;
        this.busy = true;
        this.stopTimer();
        const outgoing = this.scenes[this.active];
        const incoming = this.scenes[index];
        const image = incoming.querySelector('img');
        let ready = false;
        try {
          ready = await Promise.race([image.decode().then(() => true).catch(() => false), new Promise(resolve => { this.decodeTimer = setTimeout(() => resolve(false), 5000); })]);
        } finally { clearTimeout(this.decodeTimer); }
        if (!ready || !this.isConnected) { this.busy = false; this.schedule(); return; }
        this.classList.add('story-ready');
        outgoing.inert = true;
        if (outgoing.contains(document.activeElement)) this.chapters[index].focus({ preventScroll: true });
        this.animations = [];
        const animate = (element, frames, options) => {
          const animation = element.animate(frames, { fill: 'both', ...options });
          this.animations.push(animation);
          return animation.finished.catch(() => {});
        };
        if (!this.motion.matches) {
          const layer = document.createElement('div');
          layer.className = 'rr-story__transition';
          layer.setAttribute('aria-hidden', 'true');
          this.append(layer);
          this.transitionLayer = layer;
          const tasks = [];
          tasks.push(animate(outgoing.querySelector('.rr-hero__content'), [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-28px)' }], { duration: 420, easing: 'ease-in' }));
          const count = matchMedia('(max-width: 749px)').matches ? 3 : 5;
          for (let i = 0; i < count; i++) {
            const panel = document.createElement('div');
            panel.className = 'rr-story__panel';
            panel.style.clipPath = `inset(0 ${100 - (i + 1) * 100 / count - .04}% 0 ${i * 100 / count - .04}%)`;
            incoming.querySelectorAll(':scope > .rr-hero__media, :scope > .rr-hero__overlay, :scope > .rr-story__sale-shade').forEach(node => panel.append(node.cloneNode(true)));
            layer.append(panel);
            tasks.push(animate(panel, [{ transform: `translateY(${i % 2 ? '-105' : '105'}%)` }, { transform: 'translateY(0)' }], { duration: 1250, delay: 180 + i * 100, easing: 'cubic-bezier(.76,0,.16,1)' }));
          }
          incoming.classList.add('is-entering');
          const parts = incoming.querySelectorAll('.rr-hero__eyebrow, .rr-hero__heading, .rr-hero__sub, .rr-hero__buttons');
          parts.forEach((part, i) => tasks.push(animate(part, [{ opacity: 0, transform: 'translateY(48px)', clipPath: 'inset(0 0 100% 0)' }, { opacity: 1, transform: 'translateY(0)', clipPath: 'inset(-20% -10% -20% -10%)' }], { duration: 850, delay: 1000 + i * 110, easing: 'cubic-bezier(.16,1,.3,1)' })));
          await Promise.all(tasks);
          layer.remove();
        }
        this.animations.forEach(animation => animation.cancel());
        this.animations = [];
        incoming.classList.remove('is-entering');
        outgoing.setAttribute('aria-hidden', 'true');
        incoming.removeAttribute('aria-hidden');
        incoming.inert = false;
        this.active = index;
        this.chapters.forEach((chapter, i) => { if (i === index) chapter.setAttribute('aria-current', 'true'); else chapter.removeAttribute('aria-current'); });
        if (manual) this.querySelector('[data-scene-status]').textContent = this.chapters[index].textContent.trim();
        this.busy = false;
        this.schedule();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.stopTimer();
        clearTimeout(this.decodeTimer);
        this.animations?.forEach(animation => animation.cancel());
        this.transitionLayer?.remove();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-sale-edit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rr-sale-products')) {
    customElements.define('rr-sale-products', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.rr-sale-edit__track');
        this.cards = [...this.querySelectorAll('.rr-sale-edit__item')];
        this.previous = this.querySelector('[data-sale-prev]');
        this.next = this.querySelector('[data-sale-next]');
        this.range = this.querySelector('[data-sale-range]');
        this.controls = this.querySelector('.rr-sale-edit__controls');
        if (!this.track || !this.cards.length) return;
        this.update = () => {
          const bounds = this.track.getBoundingClientRect();
          const visible = this.cards.map((card, index) => ({ index, bounds: card.getBoundingClientRect() })).filter(card => card.bounds.left >= bounds.left - 2 && card.bounds.right <= bounds.right + 2);
          const first = visible[0]?.index ?? 0;
          const last = visible[visible.length - 1]?.index ?? first;
          this.range.textContent = first === last ? `${first + 1}` : `${first + 1}–${last + 1}`;
          const offset = Math.abs(this.track.scrollLeft);
          this.previous.disabled = offset <= 2;
          this.next.disabled = offset >= this.track.scrollWidth - this.track.clientWidth - 2;
          this.controls.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
          this.direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        };
        const move = step => {
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const pitch = this.cards[0].getBoundingClientRect().width + gap;
          const count = Math.max(1, Math.floor((this.track.clientWidth + gap) / pitch));
          this.track.scrollBy({ left: step * this.direction * pitch * count, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.previous.addEventListener('click', () => move(-1), options);
        this.next.addEventListener('click', () => move(1), options);
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move((event.key === 'ArrowRight' ? 1 : -1) * this.direction);
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(this.update);
        }, { ...options, passive: true });
        this.resizeObserver?.disconnect();
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-shop-by-style"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = root => {
      if (root.dataset.styleReady) return;
      root.dataset.styleReady = 'true';
      const entries = [...root.querySelectorAll('.rr-style-guide__entry')];
      const select = entry => {
        entries.forEach(item => { item.open = item === entry; });
        if (matchMedia('(max-width: 749px)').matches) requestAnimationFrame(() => {
          const summary = entry.querySelector('summary');
          if (summary.getBoundingClientRect().top < 100) summary.scrollIntoView({ block: 'start', behavior: 'instant' });
        });
      };
      entries.forEach(entry => {
        entry.querySelector('summary').addEventListener('click', event => {
          event.preventDefault();
          if (entry.open && matchMedia('(max-width: 749px)').matches) entry.open = false;
          else select(entry);
        });
      });
      root.addEventListener('shopify:block:select', event => {
        const entry = event.target.closest('.rr-style-guide__entry');
        if (entry) select(entry);
      });
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const prepareImages = () => root.querySelectorAll('img[loading="lazy"]').forEach(image => { image.loading = 'eager'; });
      const imageObserver = 'IntersectionObserver' in window ? new IntersectionObserver(items => {
        if (!items.some(item => item.isIntersecting)) return;
        prepareImages();
        imageObserver.disconnect();
      }, { rootMargin: '300px' }) : null;
      imageObserver?.observe(root);
      const groups = root.querySelectorAll('[data-style-enter]');
      const reveal = element => element.classList.add('is-visible');
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(items => {
        items.forEach(item => {
          if (!item.isIntersecting) return;
          reveal(item.target);
          observer.unobserve(item.target);
        });
      }, { threshold: 0, rootMargin: '0px 0px -24px 0px' }) : null;
      groups.forEach(group => {
        if (motion.matches || !observer || window.Shopify?.designMode || group.getBoundingClientRect().top < innerHeight) reveal(group);
        group.classList.add('is-ready');
        if (!group.classList.contains('is-visible')) observer.observe(group);
      });
      root.addEventListener('focusin', () => { groups.forEach(reveal); observer?.disconnect(); });
      motion.addEventListener('change', () => {
        if (motion.matches) { groups.forEach(reveal); observer?.disconnect(); }
      });
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => { observer?.disconnect(); imageObserver?.disconnect(); });
    };
    document.querySelectorAll('[data-style-guide]').forEach(init);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-style-guide]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();
})();
